import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { AcceptInvitationStepBase } from '../../shared/accept-invitation-step-base/accept-invitation-step-base';
import { InvitationCommunicationService } from '../../services/invitation-communication.service';

@Component({
    selector: 'app-about-business',
    templateUrl: './about-business.component.html',
    styleUrl: './about-business.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutBusinessComponent extends AcceptInvitationStepBase<any> {
  private readonly commService = inject(InvitationCommunicationService);

  public override readonly form = inject(FormBuilder).group({
    businessLegalName: ['', Validators.required],
    businessDBA: [''],
    //businessEmail: ['', [Validators.required, Validators.email]],
    businessPhone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    businessWebsite: ['', [Validators.pattern(/^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/)]]
  });

  public override readonly nextUrl = '../business-structure';
  public override get previousUrl(): string {
    return this.commService.role === 'supplier' ? '../personal-details' : '../request-credit-line';
  }
  protected override readonly storageKey = 'aboutBusinessForm';
}
